import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'
import Modal from '@/components/modalBase/modalBase'

@Component({
  components: {
    Modal
  }
})
export default class Alert extends Vue {
  @Prop({ default: false }) show!: Boolean
  @Prop({ default: '' }) title!: String
  @Prop({ default: '' }) message!: String
  @Prop({ default: '' }) option1Text!: String
  @Prop({ default: '' }) option2Text!: String
  @Prop({ default: 'xsmall' }) size!: String

  _option1() {
    this.$emit('option1')
  }

  _option2() {
    this.$emit('option2')
  }

  _close() {
    this.$emit('close')
  }
}
